import { GenericSlider, SliderConfig } from 'assets/js/slider.js';

class KachelSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = null;
        this.videoAnimation = null;
        this.videoObserver = null;
        this.videoPauseTimer = null;
        this.MIN_PAUSE_DURATION = 1000;
        this.MAX_PAUSE_DURATION = 3000;
    }

    connectedCallback() {
        const config = new SliderConfig({
            listSelector: '.kachel-list',
            itemSelector: '.kachel-box',
            controlsSelector: '.navigation-controls',
            prevButtonSelector: '.prev',
            nextButtonSelector: '.next'
        });

        this.slider = new GenericSlider(this, config);
        this.slider.init();

        this.initVideoAnimation();
    }

    disconnectedCallback() {
        this.slider?.destroy();
        this.cleanupVideoAnimation();
    }

    initVideoAnimation() {
        this.videoAnimation = this.querySelector('.video-animation');

        if (!this.videoAnimation) {
            return;
        }

        this.videoObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    this.loadVideoAnimation();
                    this.videoObserver.unobserve(entry.target);
                });
            },
            { threshold: 0.1 }
        );
        this.videoObserver.observe(this.videoAnimation);
    }

    loadVideoAnimation() {
        this.videoAnimation.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
        });
        this.videoAnimation.load();
        this.videoAnimation.addEventListener('ended', this.handleVideoEnded.bind(this));
        this.playVideo();
    }

    playVideo() {
        const playPromise = this.videoAnimation.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                console.log('Video autoplay prevented:', error);
            });
        }
    }

    handleVideoEnded() {
        const pauseDuration = Math.random() * (this.MAX_PAUSE_DURATION - this.MIN_PAUSE_DURATION) + this.MIN_PAUSE_DURATION;

        this.videoPauseTimer = setTimeout(() => {
            this.videoAnimation.currentTime = 0;
            const playPromise = this.videoAnimation.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log('Video replay failed:', error);
                });
            }
        }, pauseDuration);
    }

    cleanupVideoAnimation() {
        if (this.videoObserver) {
            this.videoObserver.disconnect();
        }
        if (this.videoPauseTimer) {
            clearTimeout(this.videoPauseTimer);
        }
        if (this.videoAnimation) {
            this.videoAnimation.removeEventListener('ended', this.handleVideoEnded);
        }
    }
}

if (!customElements.get("slider-kachel")) {
    customElements.define("slider-kachel", KachelSlider);
}
